import { LoadStatus } from '@rematter/frontend-lib-api-client';
import { maybe, calculateNetWeight } from '@rematter/ui-web';
import omit from 'lodash/omit';

import { simpleLoadFragment } from './fragmentsLoad';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';
import { QueryAtomResult } from '~/shared/providers/api/createQueryAtomFactory';

type BookingRef =
  | {
      id?: string | null;
      documentNumber?: string | null;
      vesselName?: string | null;
    }
  | null
  | undefined;
type AccountRef =
  | {
      id?: string | null;
      name?: string | null;
      phone?: string | null;
      email?: string | null;
      addresses?: {
        address?: {
          addressType?: string;
          streetAddress: string;
          city: string;
          state: string;
          postalCode: string;
        };
      }[];
      contacts?:
        | {
            id?: string | null;
            fullName?: string | null;
            email?: string | null;
            phone?: string | null;
          }[]
        | null;
    }
  | null
  | undefined;

export const loadListQueryAtom = createQueryAtomFactory(
  'customerPortal.loadList',
  (params: {
    status: LoadStatus[];
    searchTerm?: string;
    pagination?: {
      limit: number;
      offset?: number;
    };
  }) => ({
    loads: {
      __args: {
        filter: {
          status: params.status,
          searchTerm: params.searchTerm,
        },
        pagination: params.pagination
          ? {
              limit: params.pagination.limit,
              offset: params.pagination?.offset ?? 0,
            }
          : undefined,
      },
      page: {
        total: true,
      },
      entries: {
        ...simpleLoadFragment,
      },
    },
  }),
  {
    select: ({ loads }) => ({
      total: loads.page.total ?? 0,
      loads: loads.entries.map((load) => ({
        ...omit(load, ['documentNumber', 'salesOrder']),
        booking: load.booking as BookingRef,
        loadNumber: load.documentNumber,
        purchaseOrderNumber: maybe(load.salesOrder?.documentNumber),
        numberOfMaterials: load.lineItems?.length ?? 0,
        netWeight:
          calculateNetWeight(
            load.heavyWeight
              ? { ...load.heavyWeight, __typename: 'Weight' as const }
              : null,
            load.lightWeight
              ? { ...load.lightWeight, __typename: 'Weight' as const }
              : null,
          )?.value ?? 0,
        status: load.status,
        supplier: load.salesOrder?.account as AccountRef,
      })),
    }),
  },
);

export type LoadRecord = QueryAtomResult<
  typeof loadListQueryAtom
>['loads'][number];
